<app-loader [isLoading]="fcloading"></app-loader>
<div class="the_container">
    @if(!isMobileDevice){
    <div class="d-flex justify-content-between align-items-center find-details-heading">
        <span class="details-text">DP 4.0</span>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="bredcrumb">
                <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
                    <span (click)="onBreadcrumbClick(i)" [ngClass]="
                    !last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'
                  ">{{ breadcrumb }}</span>
                    <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
                </ng-container>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column" style="gap: 18px; width: 100%">
        <div class="manage-user-button-group">
            <!-- <button class="filter-button">
                <h1 class="filter-button-text">Filter</h1>
                <img src="assets/filter.svg" />
            </button>
            <div class="separatorDiv"></div> -->

            <div class="d-flex filter-options">
                <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select class="custom-mat-select custom-select" id="state" [(ngModel)]="selectedState"
                            placeholder="Select State">

                            <mat-option *ngFor="let state of states;let i=index" [value]="state"
                                (click)="onStateChange()">
                                {{ state }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select class="custom-mat-select" id="district" (selectionChange)="onDistrictChange()"
                            [(ngModel)]="selectedDistrict" placeholder="Select District">
                            <mat-option *ngFor="let district of districts[selectedState]" [value]="district">
                                {{ district }}
                            </mat-option>
                        </mat-select>
                        <button mat-icon-button *ngIf="selectedDistrict != ''" matSuffix
                            (click)="clearDistrictSelection()" class="clear-button">
                            <mat-icon class="clear-icon">clear</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                @if(breadcrumbs.length>1){
                <!-- <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select [formControl]="selectedOptions" class="custom-mat-select custom-select"
                            placeholder="Select criteria" (selectionChange)="onSelectCriteria()">
                            <mat-option *ngFor="let opt of options" [value]="opt">
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                        <button mat-icon-button matSuffix (click)="clearCriteria()" class="clear-button">
                            <mat-icon class="clear-icon">clear</mat-icon>
                        </button>
                    </mat-form-field>
                </div> -->
                <div class="d-flex flex-column input-div">
                    <input class="dp-input-control" type="text" style="padding:10px 12px"
                        placeholder="Search by wishlist name" aria-label="Search" [(ngModel)]="selectedWishlist"
                        (ngModelChange)="onWishlistChange($event)" [matAutocomplete]="autoId" />

                    <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
                        @for (wl of wishlists; track wl) {
                        <mat-option [value]="wl.wishlist_name" (onSelectionChange)="onwishlistSelect(wl)"
                            class="userNameEmail">
                            <div>{{ wl.wishlist_name }}</div>
                        </mat-option>
                        }
                    </mat-autocomplete>
                </div>
                <div class="d-flex flex-column input-div">
                    <input class="dp-input-control" type="text" style="padding:10px 12px"
                        placeholder="Search by wishlist name" aria-label="Search" [(ngModel)]="selectedWishlist"
                        (ngModelChange)="onWishlistChange($event)" [matAutocomplete]="autoId" />

                    <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
                        @for (wl of wishlists; track wl) {
                        <mat-option [value]="wl.wishlist_name" (onSelectionChange)="onwishlistSelect(wl)"
                            class="userNameEmail">
                            <div>{{ wl.wishlist_name }}</div>
                        </mat-option>
                        }
                    </mat-autocomplete>
                </div>
                }
            </div>
        </div>
        @if(breadcrumbs.length>1){
        <div class="d-flex align-items-center justify-content-between input-field-gap">
            <input type="text" class="dp-input-control" style="padding:10px 12px;width:320px"
                placeholder="Search by member name" [formControl]="searchInput">
        </div>
        }
        <div class="dp-table-scroll" #tableContainer *ngIf="showPinCodeData">
            <table class="dp-table">
                <thead class="dp-table-header">
                    <tr>
                        <th class="full-width">Pincode</th>
                    </tr>
                </thead>
                <tbody class="dp-table-body">
                    @if(pincodeData.length>0){ @for (row of pincodeData; track row) {
                    @if(isLoader) {
                    <tr>
                        <td [attr.colspan]="7">
                            <dp-loader></dp-loader>
                        </td>
                    </tr>
                    } @else {
                    <tr (click)="onRowClick(row)">
                        <td [attr.colspan]="7">
                            <div>
                                <span>{{ row.pincode }}</span>
                            </div>
                        </td>
                    </tr>
                    } } }@else {
                    <tr>
                        <td class="text-center" [attr.colspan]="8">
                            <span class="no-record">No records found</span>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="dp-table-scroll" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="1000" (scrolled)="fetchWishlishItemData(false)" #tableContainer
            *ngIf="!showPinCodeData">
            <table class="dp-table">
                <thead class="dp-table-header">
                    <tr>
                        <th>Wishlist Name</th>
                        <th>Member Name</th>
                        <th>Serial Number</th>
                        <th>Ritwik Name</th>
                        <th class="addr-width">Address</th>
                        <th class="full-width">Family Code</th>
                        <th class="full-width">Aadhar Number</th>
                        <th class="full-width">Pan Number</th>
                        <!-- <th>Action</th> -->
                    </tr>
                </thead>
                <tbody class="dp-table-body">
                    @if(assignedList.length>0){ @for (row of assignedList; track row) {
                    @if(isLoader) {
                    <tr>
                        <td [attr.colspan]="7">
                            <dp-loader></dp-loader>
                        </td>
                    </tr>
                    } @else {
                    <tr>
                        <td>
                            <div>
                                <span>{{ row.wishListName }}</span>
                            </div>
                        </td>
                        <td>
                            <div>
                                <span>{{ row.mNm }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="serial-no">
                                <span class="table-data-text">{{ row.serialNo }}</span>
                            </div>
                        </td>
                        <td>
                            <div>
                                <span>{{ row.rNm }}</span>
                            </div>
                        </td>
                        <td class="addr-width">
                            <div>
                                <span>{{ row.addr }}</span>
                            </div>
                        </td>
                        <td>
                            <div>
                                <span>{{ row.fc }}</span>
                            </div>
                        </td>
                        <td>
                            <div>
                                <span>{{ row.adhar ? row.adhar : '-' }}</span>
                            </div>
                        </td>
                        <td>
                            <div>
                                <span>{{ row.pan ? row.pan : '-' }}</span>
                            </div>
                        </td>
                        <!-- <td>
                            <button class="dp-secondary-btn w-100 btn-div" (click)="openDialog(row)" [disabled]="row.isDisabled">
                                {{ (row.mem_adhar_url || row.panUrl || row.adhar || row.pan) ? 'Edit' : 'Upload' }}
                            </button>

                        </td> -->
                    </tr>
                    } } }@else {
                    <tr>
                        <td class="text-center" [attr.colspan]="8">
                            <span class="no-record">No records found</span>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    } @else {
    <div class="mobileDevice">
        <div class="row">
            <div class="col-md-12">
                <div class="bredcrumb">
                    <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; let last = last">
                        <span (click)="onBreadcrumbClick(i)" [ngClass]="
                    !last ? 'brancd-prime me-2 cursor-pointer' : 'text-disable me-2'
                  ">{{ breadcrumb }}</span>
                        <img *ngIf="!last" src="../../assets/images/chevron.svg" class="me-2" />
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="manage-user-button-group">
            <button class="filter-button">
                <h1 class="filter-button-text">Filter</h1>
                <img src="assets/filter.svg" />
            </button>
            <div class="separatorDiv"></div>

            <div class="d-flex filter-options">
                <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select class="custom-mat-select custom-select" id="state" [(ngModel)]="selectedState"
                            placeholder="Select State">
                            <mat-option *ngFor="let state of states;" [value]="state" (click)="onStateChange()">
                                {{ state }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select class="custom-mat-select" id="district" (selectionChange)="onDistrictChange()"
                            [(ngModel)]="selectedDistrict" placeholder="Select District">
                            <mat-option *ngFor="let district of districts[selectedState]" [value]="district">
                                {{ district }}
                            </mat-option>
                        </mat-select>
                        <button mat-icon-button *ngIf="selectedDistrict != ''" matSuffix
                            (click)="clearDistrictSelection()" class="clear-button">
                            <mat-icon class="clear-icon">clear</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                @if(breadcrumbs.length>1){
                <!-- <div class="custom-dropdown">
                    <mat-form-field class="select-mat-form-field custom-select-form">
                        <mat-select [formControl]="selectedOptions" class="custom-mat-select custom-select"
                            placeholder="Select criteria" (selectionChange)="onSelectCriteria()">
                            <mat-option *ngFor="let opt of options" [value]="opt">
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                        <button mat-icon-button matSuffix (click)="clearCriteria()" class="clear-button">
                            <mat-icon class="clear-icon">clear</mat-icon>
                        </button>
                    </mat-form-field>
                </div> -->
                <div class="d-flex flex-column input-div">
                    <input class="dp-input-control" type="text" style="padding:10px 12px"
                        placeholder="Search by wishlist name" aria-label="Search" [(ngModel)]="selectedWishlist"
                        (ngModelChange)="onWishlistChange($event)" [matAutocomplete]="autoId" />

                    <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
                        @for (wl of wishlists; track wl) {
                        <mat-option [value]="wl.wishlist_name" (onSelectionChange)="onwishlistSelect(wl)"
                            class="userNameEmail">
                            <div>{{ wl.wishlist_name }}</div>
                        </mat-option>
                        }
                    </mat-autocomplete>
                </div>
                <div class="d-flex flex-column input-div">
                    <input class="dp-input-control" type="text" style="padding:10px 12px"
                        placeholder="Search by wishlist name" aria-label="Search" [(ngModel)]="selectedWishlist"
                        (ngModelChange)="onWishlistChange($event)" [matAutocomplete]="autoId" />

                    <mat-autocomplete autoActiveFirstOption #autoId="matAutocomplete">
                        @for (wl of wishlists; track wl) {
                        <mat-option [value]="wl.wishlist_name" (onSelectionChange)="onwishlistSelect(wl)"
                            class="userNameEmail">
                            <div>{{ wl.wishlist_name }}</div>
                        </mat-option>
                        }
                    </mat-autocomplete>
                </div>
                }
            </div>


        </div>
        @if(breadcrumbs.length>1){
        <div class="d-flex align-items-flex-end">
            <input type="text" class="dp-input-control" style="width:100%;padding:10px 12px"
                placeholder="Search by member name" [formControl]="searchInput">
        </div>
        }
        <div class="tableSec mt-10" #tableContainer *ngIf="showPinCodeData">
            <div class="tableBoxMob">
                <div class="dataList">
                    @for( lists of pincodeData; track lists){
                    <ul class="eachdataList" (click)="onRowClick(lists)">
                        <li class="data">
                            Pin code<span>{{ lists.pincode ? lists.pincode : "-" }}</span>
                        </li>
                    </ul>
                    }
                </div>
            </div>
        </div>
        <div class="tableSec mt-10" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="1000" (scrolled)="fetchWishlishItemData(false)" #tableContainer
            *ngIf="!showPinCodeData">
            <div class="tableBoxMob">
                <div class="dataList">
                    @for( lists of assignedList; track lists){
                    <ul class="eachdataList">
                        <li class="data">
                            Wishlist Name<span>{{ lists.wishListName ? lists.wishListName : "-" }}</span>
                        </li>
                        <li class="data">
                            Member Name<span>{{ lists.mNm ? lists.mNm : "-" }}</span>
                        </li>
                        <li class="data">
                            Sl.No
                            <span class="serial-no">{{
                                lists.serialNo ? lists.serialNo : "-"
                                }}</span>
                        </li>
                        <li class="data">
                            Ritwik Name <span>{{ lists.rNm ? lists.rNm
                                : "-" }}</span>
                        </li>
                        <li class="data">
                            Address <span>{{ lists.addr ? lists.addr : "-" }}</span>
                        </li>
                        <li class="data">
                            Family Code <span>{{ lists.fc ? lists.fc : "-" }}</span>
                        </li>
                        <li class="data">
                            Aadhar Number <span>{{ lists.adhar ? lists.adhar : "-" }}</span>
                        </li>
                        <li class="data">
                            Pan Number
                            <span>{{ lists.pan ? lists.pan : "-" }}</span>
                        </li>
                        <!-- <div class="secondary-button">
                            <button class="dp-secondary-btn w-100 btn-div" (click)="openDialog(lists)" [disabled]="lists.isDisabled">
                                {{ (lists.mem_adhar_url || lists.panUrl || lists.adhar || lists.pan) ? 'Edit' : 'Upload' }}
                            </button>
                        </div> -->
                    </ul>
                    }
                </div>
            </div>
        </div>
    </div>
    }
</div>